import { GDFPalletCode } from '../../../gdf/type';
import palettes from '../../../palettes/palettes';
import { generateColorExpressionFromPalette } from '../../../utils/ramp';
import { StyleFactory } from '../styling';

export const ozoneLayers: StyleFactory = (baseId) => {
    const colors = generateColorExpressionFromPalette(palettes[GDFPalletCode.ozone], ['+', ['get', 'severity'], ['literal', 1]]);
    return [
        {
            id: baseId + '-poly',
            source: baseId,
            pickable: true,
            type: 'fill',
            paint: {
                // severity starts from 0 in this product
                'fill-color': colors,
                'fill-opacity': ['global-state', 'polygon-transparency']
            }
        },
        {
            id: baseId + '-poly-hover',
            source: baseId,
            type: 'fill',
            paint: {
                'fill-color': ['case', ['boolean', ['feature-state', 'hover'], false], 'rgba(0,0,0,0.22)', 'rgba(0,0,0,0)']
            }
        }
    ];
};
